import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Button from '@ecp/common/src/components/button/bo/Button';
import DropdownMenu from '@ecp/common/src/components/dropdown/bo/DropdownMenu';

import { useConfirmDialog } from '@bo-hooks/common/useModal';

export const GridButton = ({ label, disabled, checkedRows, oneRowAvailable, onClick, width, ...props }) => {
  const handleClick = () => {
    onClick?.(checkedRows);
  };
  const disable = useMemo(() => {
    if (oneRowAvailable) {
      return checkedRows.length !== 1;
    }
    return disabled;
  }, [checkedRows, disabled, oneRowAvailable]);

  return (
    <Button
      type="Third"
      position={'left'}
      width={width}
      disabled={disable}
      padding={'0 7px'}
      onClick={handleClick}
      {...props}
    >
      {label}
    </Button>
  );
};

const GridButtonPropTypes = {
  grid: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  checkedRows: PropTypes.array,
  label: PropTypes.string,
  width: PropTypes.string,
  oneRowAvailable: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right']),
};

GridButton.propTypes = {
  ...GridButtonPropTypes,
};

GridButton.defaultProps = {
  width: 'max-content',
  position: 'left',
};
export const PrimaryGridButton = ({ ...props }) => {
  return <GridButton type="Primary" {...props} />;
};

PrimaryGridButton.propTypes = {
  ...GridButtonPropTypes,
};

PrimaryGridButton.defaultProps = {
  width: 'max-content',
  position: 'left',
};

export const GridDropdownMenu = ({
  grid,
  columnName,
  items,
  label,
  onClick,
  menuIcon,
  checkedRows,
  disabled,
  oneRowAvailable,
  validator,
  dialog,
  ...props
}) => {
  const { showConfirmDialog } = useConfirmDialog();

  const changeValues = async (item) => {
    const valid = await validator?.(item, checkedRows);

    if (valid) {
      checkedRows.map((row) => {
        grid?.current?.setValue?.(row, columnName, item.key);
      });
    }

    onClick?.(item, checkedRows, valid);
  };
  const handleClick = async (item) => {
    if (dialog) {
      showConfirmDialog(
        typeof dialog.message === 'string' ? dialog.message : dialog.message(item),
        async () => await changeValues(item),
        () => {},
        dialog.confirmButtonText
      );
    } else {
      await changeValues(item);
    }
  };

  const disable = useMemo(() => {
    if (oneRowAvailable) {
      return checkedRows.length !== 1;
    }
    return disabled;
  }, [checkedRows, disabled, oneRowAvailable]);

  return (
    <DropdownMenu
      position={'left'}
      disabled={disable}
      items={items}
      menuIcon={menuIcon}
      menuLabel={label}
      onClick={handleClick}
      {...props}
    />
  );
};

GridDropdownMenu.propTypes = {
  ...GridButtonPropTypes,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool,
    })
  ),
  columnName: PropTypes.string,
  value: PropTypes.object,
  onClick: PropTypes.func,
  menuIcon: PropTypes.elementType,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  oneRowAvailable: PropTypes.bool,
  validator: PropTypes.func,
  dialog: PropTypes.object,
};

GridDropdownMenu.defaultProps = {
  width: '110px',
  position: 'left',
  validator: () => true,
  checkedRows: [],
};

export default GridButton;
